import styled from 'styled-components';
export const Wrapper = styled.ul `
  display: flex;
`;
export const Element = styled.li ``;
